import { Link } from 'react-router-dom';

const PickupButton = () => (
  <Link to="http://devis.repairjeans.com" target="_blank" rel="noopener noreferrer" className="pickup-btn">
    <span className="pickup-btn-icon" aria-hidden="true">
      <i className="ri-shopping-bag-3-line"></i>
    </span>
    Récupérez votre jean réparé
    <i className="ri-arrow-right-line pickup-btn-arrow" aria-hidden="true"></i>
  </Link>
);

export default PickupButton;
